import React, { useState, useEffect } from 'react';
import {
  MotifButton,
  MotifTabNavigation as MotifTabNav,
  MotifTabControl,
} from '@ey-xd/motif-react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
  Recoil_Msl_Quarter_State,
  Pl_Failure_Modal_State,
  Current_User,
  Recoil_All_Accounts_Quarter_State,
  Active_Tab_Msl,
  System_Date_Time_State,
  Next_Button_Active_State,
  All_Month_MSL_Data_State,
  Pl_Submit_Success_Modal_State,
  Country_Name_State,
  Refresh_Pills_Status_State,
  Submission_Failure,
  Loading_Modal_State,
} from '@recoil/recoil';
import { dateFormatMonth, getPeriodForMonth, getCurrentMonth } from '@util/commonUtil';
import LoadingModal from '@organisms/modals/loadingModal';

import {
  SubmitButtonContainer,
  SubHeaderContainerMsl,
  TabStep,
  TabMonth,
  TabDates,
  TabPrevButton,
  TabNextButton,
} from '@atoms/subHeaderText/subHeader.styles';
import { PAGE, SOURCE, LOGOUT_SCREEN } from '@constants/commonConstants';
import {
  getAlertBarDetails,
  isCurrentUserExist,
  logError,
  MslPostChangeKeys,
} from '@util/commonFunctions';
import FailureTransactionModal from '@organisms/modals/failureTransactionModal';
import SuccessTransactionModal from '@organisms/modals/SuccessTransactionModal';
import '@molecules/msl/styles/tableHeaderStyle.css';
import { getLogOutStatus, getOpportunitiesDue } from '@services/commonServices';
import { useNavigate } from 'react-router-dom';

import { submitMSLopportunity } from '@services/mslServices';
import { appInsights } from '@services/appInsightsService';
import { hasSystemTimePassed } from '../../../../util/commonUtil';

const SubHeaderMSL2 = () => {
  const [quarterData, setQuarterData] = useRecoilState(Recoil_Msl_Quarter_State);
  const showFailureSubmitModal = useRecoilValue(Pl_Failure_Modal_State);
  const currentUser = useRecoilValue(Current_User);
  const allAccountsQuarterData = useRecoilValue(Recoil_All_Accounts_Quarter_State);
  const systemDateTime = useRecoilValue(System_Date_Time_State);
  const [tabActive, setTabActive] = useRecoilState(Active_Tab_Msl);
  const [nextButtonActive, setNextButtonActive] = useRecoilState(Next_Button_Active_State);
  //Below Line direct-import-and-test-needed
  const [quarterChipInfo, setQuarterChipInfo] = useState({}); // eslint-disable-line
  //Below Line direct-import-and-test-needed
  const [monthChipInfo, setMonthChipInfo] = useState({}); // eslint-disable-line
  const setShowFailureSubmitModal = useSetRecoilState(Pl_Failure_Modal_State);
  const refreshPillStatus = useRecoilValue(Refresh_Pills_Status_State);

  const allMonthData = useRecoilValue(All_Month_MSL_Data_State);
  const countryName = useRecoilValue(Country_Name_State);
  const CurrentMonth = getCurrentMonth(systemDateTime);

  const [, setShowSubmissionFailureModal] = useRecoilState(Submission_Failure);
  const [showLoadingModal, setShowLoadingModal] = useRecoilState(Loading_Modal_State);
  const [showSubmitConfirmationModal, setShowSubmitConfirmationModal] = useRecoilState(
    Pl_Submit_Success_Modal_State,
  );

  let alertStatusDetails;
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser !== null) {
      getOpportunitiesDue(currentUser.role, currentUser.email, systemDateTime.split('T')[0])
        .then(result => {
          setQuarterData(result);
        })
        .catch(error => {
          logError('getOpportunitiesDue', error);
        });
    }
  }, [currentUser]);

  useEffect(() => {
    if (quarterData !== null && currentUser !== null && allAccountsQuarterData !== null) {
      getMotifChip();
    }
  }, [quarterData, currentUser, allAccountsQuarterData, refreshPillStatus]);

  const month = quarterData ? quarterData.month : '';
  const SecondMonth = quarterData ? quarterData.next_month : '';
  const ThirdMonth = quarterData ? quarterData.next2next_month : '';
  const StartDate = quarterData ? dateFormatMonth(quarterData.current_month_start_date) : '';
  const EndDate = quarterData ? dateFormatMonth(quarterData.current_month_end_date) : '';
  const SecondMonthStartDate = quarterData
    ? dateFormatMonth(quarterData.next_month_start_date)
    : '';
  const SecondMonthEndDate = quarterData ? dateFormatMonth(quarterData.next_month_end_dt_date) : '';
  const ThirdMonthStartDate = quarterData
    ? dateFormatMonth(quarterData.next2next_month_start_date)
    : '';
  const ThirdMonthEndDate = quarterData
    ? dateFormatMonth(quarterData.next2next_month_end_date)
    : '';

  const TodaysDate = systemDateTime ? new Date(systemDateTime) : new Date();
  const personaStartDateCheck = quarterData ? new Date(quarterData.persona_startdate) : new Date();
  const personaCloseDateCheck = quarterData ? new Date(quarterData.persona_closedate) : new Date();
  const isReadOnly = localStorage.getItem('isReadOnly') === 'true';
  let IsSubmitDisabled = false;

  IsSubmitDisabled =
    (isReadOnly && tabActive === 2) ||
    (!(TodaysDate >= personaStartDateCheck && TodaysDate <= personaCloseDateCheck) &&
      tabActive === 2) ||
    (tabActive === 2 &&
      localStorage.getItem('isSuperUser') == 'true' &&
      localStorage.getItem('targetUserEmail') !== 'null')
      ? true // Disable
      : false; // Enable

  const getMotifChip = async () => {
    const apiPayload = {
      email: localStorage.getItem('mslDelegate')
        ? localStorage.getItem('mslDelegate')
        : currentUser.email,
      role: currentUser.role,
      month: quarterData.month?.toLowerCase(),
      year: quarterData.fiscal_year,
      accountId: currentUser.account_id,
      read_only: localStorage.getItem('isReadOnly') === 'true' ? true : false,
    };

    try {
      alertStatusDetails = await getAlertBarDetails(
        allAccountsQuarterData[apiPayload.role],
        apiPayload,
        PAGE.FORECAST,
        systemDateTime,
      );

      const monthVariant =
        (alertStatusDetails.userDropdownChip &&
          alertStatusDetails.userDropdownChip.includes('Opens on')) ||
        alertStatusDetails.userDropdownChip.includes('Due on')
          ? 'monochrome-dark'
          : alertStatusDetails.type;

      setQuarterChipInfo({ ...alertStatusDetails, type: monthVariant });
    } catch (error) {
      logError('getAlertBarDetails', error);
    }

    try {
      alertStatusDetails = await getAlertBarDetails(
        allAccountsQuarterData[apiPayload.role],
        apiPayload,
        PAGE.FORECAST,
        systemDateTime,
      );

      const monthVariant =
        (alertStatusDetails.userDropdownChip &&
          alertStatusDetails.userDropdownChip.includes('Opens on')) ||
        alertStatusDetails.userDropdownChip.includes('Due on')
          ? 'monochrome-dark'
          : alertStatusDetails.type;

      setMonthChipInfo({ ...alertStatusDetails, type: monthVariant });
    } catch (error) {
      logError('getAlertBarDetails', error);
    }
  };

  const submitOpportunities = async () => {
    const ACCOUNTID = currentUser.account_id;
    const MONTH = quarterData.month;
    const YEAR = quarterData.fiscal_year;
    const QUARTER = quarterData.quarter;

    const isRollingData = true;
    const SubmissionType = 'month';

    let JUDGE_DATA_REQ_BODY = []; // Jugde Data
    let ROLLING_JUDGE_DATA_REQ_BODY = []; // Rolling Judge Data

    const judgeData = [];
    Object.keys(allMonthData).forEach(key => {
      const item = allMonthData[key];

      if (item.length !== 0) {
        item.forEach(subItem => {
          if (subItem.category === 'Your Judge') {
            judgeData.push({ ...subItem });
          }
        });
      }
    });

    JUDGE_DATA_REQ_BODY = judgeData?.find(
      obj => obj.month?.toLowerCase() === CurrentMonth?.toLowerCase(),
    );

    if (Object.keys(judgeData).length !== 0) {
      JUDGE_DATA_REQ_BODY = MslPostChangeKeys([JUDGE_DATA_REQ_BODY], SubmissionType, false); // eslint-disable-line
      ROLLING_JUDGE_DATA_REQ_BODY = MslPostChangeKeys(judgeData, SubmissionType, isRollingData);
    }

    const RequestBody = {
      market_segment_id: ACCOUNTID,
      month: MONTH,
      year: YEAR,
      quarter: QUARTER,
      email: localStorage?.getItem('mslDelegate')
        ? localStorage?.getItem('mslDelegate')
        : currentUser.email,
      role: currentUser.role,
      performing_segment: currentUser.account_id,
      msl: JUDGE_DATA_REQ_BODY[0], // [0]th object because its always have only one object
      rolling_judge: ROLLING_JUDGE_DATA_REQ_BODY,
      delegate_id: localStorage?.getItem('mslDelegate') ? currentUser.email : null,
    };

    try {
      const postSubmitMSLopportunity = await submitMSLopportunity(RequestBody);
      if (postSubmitMSLopportunity === true) {
        // If Response true
        appInsights.trackTrace({
          message: JSON.stringify({
            message: `Msl successfully submitted opportunitis for ${QUARTER} ${MONTH} ${YEAR}  `,
            userId: localStorage.getItem('userEmail'),
            source: SOURCE.FRONTEND,
          }),
          severityLevel: 1, // 1 represents response log
        });
        setShowLoadingModal(false); // Hide Loading Modal
        setShowSubmitConfirmationModal(true); // Showing Success Modal When Response is 200
      } else {
        setShowLoadingModal(false); // Hide Loading Modal
        setShowFailureSubmitModal(true); // Showing Error Modal
      }
    } catch (error) {
      setShowLoadingModal(false); // Hide Loading Modal
      setShowFailureSubmitModal(true); // Showing Error Modal
      appInsights.trackTrace({
        message: JSON.stringify({
          message: `Error while submitting msl opportunities: ${error}  `,
          userId: localStorage.getItem('userEmail'),
          source: SOURCE.FRONTEND,
        }),
        severityLevel: 3, // 3 represents failure
      });
    }
  };

  const initSubmission = async () => {
    const isUserExist = await isCurrentUserExist(countryName);
    if (isUserExist) {
      const isSystemTimePassed = hasSystemTimePassed(personaCloseDateCheck);
      if (isSystemTimePassed) {
        setShowSubmissionFailureModal(true);
      } else {
        setShowLoadingModal(true);
        // Submit API Function Call
        submitOpportunities();
      }
    } else {
      getLogOutStatus(localStorage.getItem('userEmail'))
        .then(() => {
          localStorage.clear();
          sessionStorage.clear();
          navigate('/logout', {
            state: {
              TITLE: LOGOUT_SCREEN.HEADER_TITLE,
              DESCRIPTION: LOGOUT_SCREEN.DESCRIPTION,
              BUTTON_TITLE: LOGOUT_SCREEN.BUTTON_TITLE,
            },
          });
        })
        .catch(error => {
          appInsights.trackTrace({
            message: JSON.stringify({
              message: `Error while submitting msl opportunities: ${error}  `,
              userId: localStorage.getItem('userEmail'),
              source: SOURCE.FRONTEND,
            }),
            severityLevel: 3, // 3 represents failure
          });
        });
    }
  };

  useEffect(() => {
    setTabActive(0);
  }, []);

  return (
    <SubHeaderContainerMsl>
      <LoadingModal showLoadingModal={showLoadingModal} />
      <SuccessTransactionModal showSubmitConfirmationModal={showSubmitConfirmationModal} />
      <div style={{ display: 'flex', justifyContent: 'space-between', paddingRight: 10, gap: 15 }}>
        <MotifTabNav>
          <MotifTabControl
            disabled
            className={tabActive === 0 ? 'motif-active' : ''}
            style={tabActive === 0 ? { background: '#FFE600' } : {}}
          >
            <TabStep>STEP 1: Final Forecast</TabStep>
            <TabMonth>
              {' '}
              Fiscal {month?.charAt(0).toUpperCase() + month?.slice(1)} (
              {getPeriodForMonth(month?.charAt(0).toUpperCase() + month?.slice(1))}){' '}
            </TabMonth>
            <TabDates>
              {' '}
              {StartDate}- {EndDate}
            </TabDates>
          </MotifTabControl>

          <MotifTabControl
            disabled
            className={tabActive === 1 ? 'motif-active' : ''}
            style={tabActive === 1 ? { background: '#FFE600' } : {}}
          >
            <TabStep>STEP 2: Projected Forecast</TabStep>
            <TabMonth>
              Fiscal {SecondMonth?.charAt(0).toUpperCase() + SecondMonth?.slice(1)} (
              {getPeriodForMonth(SecondMonth)})
            </TabMonth>
            <TabDates>
              {' '}
              {SecondMonthStartDate}- {SecondMonthEndDate}
            </TabDates>
          </MotifTabControl>

          <MotifTabControl
            disabled
            className={tabActive === 2 ? 'motif-active' : ''}
            style={tabActive === 2 ? { background: '#FFE600' } : {}}
          >
            <TabStep>STEP 3: Projected Forecast</TabStep>
            <TabMonth>
              Fiscal {ThirdMonth?.charAt(0).toUpperCase() + ThirdMonth?.slice(1)} (
              {getPeriodForMonth(ThirdMonth)})
            </TabMonth>
            <TabDates>
              {' '}
              {ThirdMonthStartDate}- {ThirdMonthEndDate}
            </TabDates>
          </MotifTabControl>
        </MotifTabNav>
      </div>

      <SubmitButtonContainer>
        <div style={{ padding: 20, display: 'flex' }}>
          <TabPrevButton>
            <MotifButton
              onClick={() => {
                setTabActive(tabActive - 1);
              }}
              disabled={tabActive === 0}
              style={
                tabActive === 0
                  ? { background: ' #FFFFFF', color: '#2E2E38', border: '1px solid #2E2E38' }
                  : {}
              }
              className="TabPrevButton"
            >
              Previous
            </MotifButton>
          </TabPrevButton>
          <TabNextButton>
            {nextButtonActive ? (
              <MotifButton
                onClick={() => {
                  if (tabActive < 2) {
                    setNextButtonActive(false);
                    setTabActive(tabActive + 1);
                  } else {
                    initSubmission();
                  }
                }}
                disabled={IsSubmitDisabled}
                className="TabNextButton"
              >
                {tabActive === 2 ? 'Submit' : 'Next'}
              </MotifButton>
            ) : (
              <MotifButton disabled={true} className="TabNextButton">
                Next
              </MotifButton>
            )}
          </TabNextButton>
        </div>
        <FailureTransactionModal showFailureSubmitModal={showFailureSubmitModal} />
      </SubmitButtonContainer>
    </SubHeaderContainerMsl>
  );
};

export default SubHeaderMSL2;
